import SelectChips from './SelectChips';

export default SelectChips;
